import axios from 'axios';
import router from './router';
import store from './store';

export default function axiosConfig() {
  // 🎈 @mattia imposta l'url della api nel file .env
    axios.defaults.baseURL = process.env.VUE_APP_API_HOST;
    axios.defaults.headers = {
        'Content-Type': 'application/json;', "Access-Control-Allow-Origin":"*"};

    if (window.SETTINGS && window.SETTINGS.apiUrl) {
        axios.defaults.baseURL = window.SETTINGS.apiUrl;
    }
  


  axios.interceptors.request.use(
    config => {
      store.commit('changeLoadingState', { value: true });
      return config;
    },
    error => {
      return Promise.reject(error);
    }
  );
  axios.interceptors.response.use(
    response => {
      store.commit('changeLoadingState', { value: false });
      return response;
    },
    error => {
      store.commit('changeLoadingState', { value: false });
      if (error.response.status == 400) {
        // validation error
        }

        if (error.response.status == 401) {
          store.commit('clearAuth');
           router.push({ name: 'route-login' });
        }
      if (error.response.status == 500) {
        // server error
      }
      return Promise.reject(error);
    }
  );
}
